import { render, staticRenderFns } from "./StudentsHeader.vue?vue&type=template&id=5ba9691f&scoped=true&"
import script from "./StudentsHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentsHeader.vue?vue&type=style&index=0&id=5ba9691f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba9691f",
  null
  
)

export default component.exports